import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchNextEventList } from '../../../store/actions/planner/EventAction';
import { getSiteEventEditRoute, getSiteEventsRoute } from '../../../router/routes/site/factory/planner';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import Button from '../inputs/Button';
import { BlackPaper } from '../surface/Paper';
import { Box, Card, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import Link from '../typography/Link';
import { Launch } from '@mui/icons-material';
import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';

const UppercaseTypography = styled(Typography)({
  textTransform: 'uppercase',
});

const CenteredBox = styled(Box)({
  textAlign: 'center', 
  width: '100%'
});

const NextEvent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  // Use selector hooks instead of connect
  const events = useSelector(state => state.event.nextEventList);
  const planner = useSelector(state => state.schedule.planner);

  // Dispatch action function wrapped in useCallback
  const handleFetchNextEventList = useCallback((plannerId, silent = false) => {
    dispatch(fetchNextEventList(plannerId, silent));
  }, [dispatch]);

  useEffect(() => {
    if (!planner) return;
    handleFetchNextEventList(planner.Planner__);
  }, [planner, handleFetchNextEventList]);

  useEffect(() => {
    if (!planner) return;

    const refreshInterval = setInterval(() => {
      if (!planner) return;
      handleFetchNextEventList(planner.Planner__, true);
    }, 30000);

    return () => {
      clearInterval(refreshInterval);
    };
  }, [planner, handleFetchNextEventList]);

  return (
    <Card elevation={0} component={BlackPaper} style={{height: '100%'}}>
      <CardContent>
        <Grid container spacing={3} direction="column" justifyContent="space-between">
          <Grid item xs={12}>
            <UppercaseTypography variant="h5" align="center">
              {t('next_event_title')}
            </UppercaseTypography>
          </Grid>
          <Grid item xs={12}>
            <Table>
              <TableHead>
                <TableCell>{t('event_date')}</TableCell>
                <TableCell>{t('event_title')}</TableCell>
                <TableCell align="right">{t('ticket_sold')}</TableCell>
              </TableHead>
              <TableBody>
                {events.map(e => (
                  <TableRow key={e.Planner_Event__}>
                    <TableCell>{moment(parseInt(e.Event_Date.unixms)).format('LLL')}</TableCell>
                    <TableCell>
                      <Link to={getSiteEventEditRoute(e.Planner_Event__)}>
                        {e.Schedule.Content_Cms_Entry_Data.Title}
                      </Link>
                    </TableCell>
                    <TableCell align="right">{e.Total_Count}/{e.Total_Capacity}</TableCell>
                  </TableRow>
                ))}
                {(events.length < 1) && (
                  <TableRow>
                    <TableCell colSpan={3}>
                      <Typography align="center">
                        {t('no_next_event')}
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={12}>
            <CenteredBox>
              <Button 
                variant="text" 
                color="primary" 
                endIcon={<Launch />} 
                component={Link}
                to={getSiteEventsRoute()}
              >
                {t('see_events_btn')}
              </Button>
            </CenteredBox>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default NextEvent;